import { render, staticRenderFns } from "./newSupervise.vue?vue&type=template&id=3faebaef&scoped=true&"
import script from "./newSupervise.vue?vue&type=script&lang=js&"
export * from "./newSupervise.vue?vue&type=script&lang=js&"
import style0 from "./newSupervise.vue?vue&type=style&index=0&id=3faebaef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faebaef",
  null
  
)

export default component.exports